module.exports = __webpack_public_path__ + "static/media/R-F-036.399b8bae.webp";